import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clapperboard, Plus, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

const linkBase =
  "text-sm font-medium tracking-wide transition-colors duration-200 hover:text-white";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAuthed = user && user !== null;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <Clapperboard className="w-6 h-6 text-[#E50914] group-hover:rotate-6 transition-transform duration-300" />
          <span className="font-display text-xl font-bold tracking-tight">
            DinnerMovie<span className="text-[#E50914]">.ai</span>
          </span>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-6">
          <NavLink
            to="/community"
            data-testid="nav-community"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-white" : "text-white/60"}`
            }
          >
            Community
          </NavLink>

          {isAuthed ? (
            <>
              <NavLink
                to="/pairings"
                data-testid="nav-my-pairings"
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? "text-white" : "text-white/60"}`
                }
              >
                My Pairings
              </NavLink>
              <Button
                onClick={() => navigate("/generate")}
                data-testid="nav-generate-btn"
                className="rounded-full bg-[#E50914] hover:bg-[#c00811] text-white h-9 px-4 text-sm"
              >
                <Plus className="w-4 h-4 mr-1" /> Generate
              </Button>
              <div className="hidden sm:flex items-center gap-3 pl-2 border-l border-white/10">
                <span
                  className="text-sm text-white/70"
                  data-testid="nav-username"
                >
                  {user.username}
                </span>
                <button
                  onClick={handleLogout}
                  data-testid="nav-logout-btn"
                  className="text-white/50 hover:text-[#E50914] transition-colors"
                  title="Log out"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            </>
          ) : (
            <>
              <NavLink
                to="/login"
                data-testid="nav-login"
                className={`${linkBase} text-white/60`}
              >
                Login
              </NavLink>
              <Button
                onClick={() => navigate("/generate")}
                data-testid="nav-guest-generate-btn"
                className="rounded-full bg-[#E50914] hover:bg-[#c00811] text-white h-9 px-4 text-sm"
              >
                <Plus className="w-4 h-4 mr-1" /> Generate
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
